/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_seller$ref = any;
export type PdpSharedDealerDetailsHeader_seller = {
    readonly monthsSinceStartDate: number | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly " $refType": PdpSharedDealerDetailsHeader_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDealerDetailsHeader_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "monthsSinceStartDate",
            "name": "timeSinceStartDate",
            "args": [
                {
                    "kind": "Literal",
                    "name": "unit",
                    "value": "MONTH"
                }
            ],
            "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "sellerProfile",
            "storageKey": null,
            "args": null,
            "concreteType": "SellerProfile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "company",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '854a1041998f4df01e6186b6397ac187';
export default node;
